<template>
  <div class="custom" ref="custom">
    <slot name="prefixIcon" class="prefixIcon"></slot>
    <input v-model="localValue" autocomplete="off" :type="inpType" class="myInp" ref="myInp" :placeholder="placeholder">
    <img class="suffixIcon" :src="suffixIcon" ref="suffixIcon" @click="clearVal" />
  </div>
</template>

<script>
export default {
  props: {
    inpType: {
      type: String,
      default:() => 'text'
    },
    placeholder: {
      type: String,
      default:() => ''
    },
    suffixIcon:{
      type: String,
      default:() =>'../assets/sites/icon4.png'
    },
    inputVal:{
      type: String,
      default:() => ''
    }
  },
  data() {
    return {
      localValue: ''
    } 
  },
  watch:{
    inputVal: {
      handler(val) {
        if(val!==this.localValue) {
          this.localValue = val
        }
      },
      immediate:true,
      deep:true
    },
    localValue(v) {
        this.$emit('changeInp', v);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.custom && this.$refs.custom.addEventListener('mouseover', () => {
        this.$refs.suffixIcon.style.visibility = 'visible';
      })
      this.$refs.custom && this.$refs.custom.addEventListener('mouseout', () => {
        this.$refs.suffixIcon.style.visibility = 'hidden';
      })
    })
  },
  methods:{
    clearVal() {
      this.localValue = ''
    },
  }
}
</script>

<style lang='scss'>
  .custom {
    display: -webkit-flex;
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #17ECFE;
    .suffixIcon {
      cursor: pointer;
      visibility: hidden;
    }
    .myInp {
      border: none;
      outline: none;
      width: 330px;
      height: 38px;
      background-color: transparent!important;
      margin-left: 20px;
      font-size: 16px;
      color: #17ECFE;
    }
  }
  input::-webkit-input-placeholder {
    color: #17ECFE;
    letter-spacing: 4px;
  }
  input:-webkit-autofill {
    -webkit-text-fill-color: #17ECFE !important;
    background-color:transparent!important;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  input:-internal-autofill-selected {
    background-color: transparent!important;
  }
</style>